import styled from 'styled-components';
import { ENDPOINT_RSI_LOGOUT } from 'constants/constants';
import { logout } from 'utils/commonService';

// min-height はRSI共通設ヘッダー分を引いている
const Content = styled.div`
  margin: 0 auto;
  text-align: center;
  min-height: calc(100vh - 62px);
  max-width: 1024px;
  width: 100%;
`;

const Title = styled.div`
  background-image: url(data-url:../../img/ricohLogo.png);
  background-repeat: no-repeat;
  background-color: transparent;
  background-position: 0 0;
  margin: 0;
  padding: 0;
  width: 140px;
  height: 48px;
`;

const ErrorTitle = styled.div`
  text-align: center;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: 0.7pt;
  text-shadow: 0 0 2px #bbb;
  margin: 20px;
`;

const ErrorDetail = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
`;

const Line = styled.hr`
  height: 1px;
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  border: 0 none;
  margin: 20px 0;
`;

const LineWrapper = styled.div`
  text-align: center;
`;

const Button = styled.button`
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 6px 60px;
  text-align: center;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  letter-spacing: 0.7pt;
  background-color: #3498db;
  border-color: #258cd1;
  color: #fff;
  text-decoration: none;
`;

export const Error = () => {
  const handleOnClick = async () => {
    await logout()
    .then(async () => {
      window.location.assign(`${ENDPOINT_RSI_LOGOUT}?url=${process.env.REACT_APP_ROOT_URL}`);
    })
  };
  return (
    <Content>
      <Title />
      <ErrorTitle>Error</ErrorTitle>
      <ErrorDetail>このページへのアクセス権限がありません</ErrorDetail>
      <Line />
      <LineWrapper>
        <Button
          onClick={handleOnClick}
        >
          ログアウト
        </Button>
      </LineWrapper>
    </Content>
  );
};
